var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricCirculationRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eletric") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uD83D\\uDCCFCirculation-Rules",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circulation-Rules_MODAL-LISBON_-2",
    transform: "translate(-804.000000, -263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eletric",
    transform: "translate(804.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#020078",
    strokeWidth: 0.833333333,
    fill: "#29E7D6",
    x: 0.416666667,
    y: 0.416666667,
    width: 25.1666667,
    height: 25.1666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Plug",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1666667,4 C14.626904,4 15,4.37309604 15,4.83333333 L15,7.29999673 L17.5,7.29999673 C17.9602373,7.29999673 18.3333333,7.66936145 18.3333333,8.12499592 L18.3333333,13.8999902 C18.3333333,15.7225281 16.8409492,17.1999869 15,17.1999869 L12.5,17.1999869 L12.5,18.8499853 L16.6750008,18.8499853 C17.1306353,18.8499853 17.5,19.21935 17.5,19.6749845 C17.5,20.130619 17.1306353,20.4999837 16.6750008,20.4999837 L12.5,20.4999837 C11.5795254,20.4999837 10.8333333,19.7612542 10.8333333,18.8499853 L10.8333333,17.1999869 L8.33333333,17.1999869 C6.49238417,17.1999869 5,15.7225281 5,13.8999902 L5,8.12499592 C5,7.66936145 5.37309604,7.29999673 5.83333333,7.29999673 L8.33333333,7.29999673 L8.33333333,4.83333333 C8.33333333,4.37309604 8.70642938,4 9.16666667,4 C9.62690396,4 10,4.37309604 10,4.83333333 L10,7.29999673 L13.3333333,7.29999673 L13.3333333,4.83333333 C13.3333333,4.37309604 13.7064294,4 14.1666667,4 Z M6.66666667,13.8999902 C6.66666667,14.8112591 7.41285875,15.5499886 8.33333333,15.5499886 L15,15.5499886 C15.9204746,15.5499886 16.6666667,14.8112591 16.6666667,13.8999902 L16.6666667,8.9499951 L6.66666667,8.9499951 L6.66666667,13.8999902 Z M11.6666667,12.6624914 C12.126904,12.6624914 12.5,13.0318561 12.5,13.4874906 C12.5,13.9431251 12.126904,14.3124898 11.6666667,14.3124898 C11.2064294,14.3124898 10.8333333,13.9431251 10.8333333,13.4874906 C10.8333333,13.0318561 11.2064294,12.6624914 11.6666667,12.6624914 Z",
    id: "Combined-Shape",
    fill: "#020078",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCirculationRules);
export default __webpack_public_path__ + "static/media/electric_circulation_rules.5c182c1122791d00bc17a262112897e8.svg";
export { ForwardRef as ReactComponent };